import { NoOp } from 'utils/noop';

import { PanelContent } from './PanelContent';
import { PaginationContextProvider } from '../../contexts/InternalPaginationProvider';
import { PanelContextProvider } from '../../contexts/PanelProvider';
import { MovableInkIntegrationContextProvider } from '../../contexts/MovableInkIntegrationContext';
import { MovableInkCampaignContextProvider } from '../../contexts/MovableInkCampaignContext';
import { MovableInkBlockContextProvider } from '../../contexts/MovableInkBlockContext';
import { ImageMetadata } from '../../types';

type Props = {
  canStyle?: boolean;
  onCancel?: NoOp;
  onClose: NoOp;
  onInsert?: (imgAttrs: Record<string, string>, linkAttrs: Record<string, string>) => void;
  onSelect?: (url: string, imgMetadata?: ImageMetadata) => void;
  selectedEditorImageNode?: HTMLImageElement;
  selectedEditorImageAnchorNode?: HTMLAnchorElement;
};

export const MovableInkPanel = ({
  canStyle = true, // allows manipulation of height, width, and style attributes
  onCancel, // close the panel without select or insert (necessary for drag-and-drop (Bee) - includes additional instructions to terminate the insertion without a result)
  onClose, // close the panel after selection or insertion
  onInsert, // insert html into editor
  onSelect, // select url of image only
  selectedEditorImageNode, // optional for the HTML editors only (does not apply to input fields)
  selectedEditorImageAnchorNode,
}: Props) => {
  const onCancelPanel = onCancel ?? onClose;

  return (
    <PaginationContextProvider>
      <MovableInkIntegrationContextProvider>
        <MovableInkCampaignContextProvider>
          <MovableInkBlockContextProvider>
            <PanelContextProvider
              canStyle={canStyle}
              onCancel={onCancelPanel}
              onClose={onClose}
              onInsert={onInsert}
              onSelect={onSelect}
              selectedEditorImageNode={selectedEditorImageNode}
              selectedEditorImageAnchorNode={selectedEditorImageAnchorNode}
            >
              <PanelContent />
            </PanelContextProvider>
          </MovableInkBlockContextProvider>
        </MovableInkCampaignContextProvider>
      </MovableInkIntegrationContextProvider>
    </PaginationContextProvider>
  );
};
